import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Alert from '@mui/material/Alert';
import { DataGrid } from '@mui/x-data-grid';

import { markJobAsComplete, fetchActiveJobs } from './action';
import { selectActiveJobs, selectUpdateJobError } from './selector';

const CompletionApprovalList = () => {
  const dispatch = useDispatch();
  const completionApprovals = useSelector(selectActiveJobs);
  const updateJobError = useSelector(selectUpdateJobError);

  const [selectedJob, setSelectedJob] = useState(null);

  useEffect(() => {
    dispatch(fetchActiveJobs());
  }, [dispatch]);

  const petTypes = [
    { label: 'Cat', value: 'cat' },
    { label: 'Dog', value: 'dog' },
  ];

  const onCompleteJob = (row) => {
    setSelectedJob(row);
  };

  const handleCloseDialog = () => {
    setSelectedJob(null);
  };

  const handleCompleteJob = () => {
    dispatch(markJobAsComplete(selectedJob));
    setSelectedJob(null);
  };

  const columns = [
    { field: '_id', sortable: false, headerName: 'Job ID', width: 220 },
    { field: 'selectedSitterId', headerName: 'Sitter ID', width: 220 },
    {
      field: 'createdAt',
      headerName: 'Created on',
      width: 150,
      valueGetter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleDateString('en-US');
      }
    },
    {
      field: 'petName',
      headerName: 'Pet Name',
      width: 150,
      valueGetter: (params) => params.row.jobDetails.petName,
    },
    {
      field: 'petType',
      headerName: 'Pet Type',
      width: 150,
      valueGetter: (params) => {
        const { petType } = params.row.jobDetails;
        return petTypes.find(pet => pet.value === petType)?.label;
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 200,
      isableClickEventBubbling: true,
      sortable: false,
      renderCell: (params) => (
        <Button variant="text" onClick={() => onCompleteJob(params.row)}>
          Release Funds
        </Button>
      ),
    },
  ];

  return (
    <Container component="main" maxWidth="lg" sx={{ pt: 6 }}>
      <Dialog maxWidth="xs" open={selectedJob !== null}>
        <DialogTitle sx={{ pb: 3.5 }}>Confirm completion</DialogTitle>
        <DialogContent>
          Are you sure you wish to mark the job as complete?
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button autoFocus onClick={handleCloseDialog}>No</Button>
          <Button onClick={handleCompleteJob}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Typography variant="h5" component="h1">
        Invoice Pending: {completionApprovals.length}
      </Typography>
      {updateJobError && (
        <Alert severity="error" sx={{ mt: 1 }}>{updateJobError}</Alert>
      )}
      <div
        style={{
          height: 80 * completionApprovals.length + 200,
          width: '100%',
          marginTop: 20,
        }}
      >
        <DataGrid
          rows={completionApprovals}
          columns={columns}
          getRowId={row => row._id}
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </div>
    </Container>
  );
};

export default CompletionApprovalList;
